var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.95 6.3v.475c0 4.917-3.6 10.592-10.208 10.592a9.928 9.928 0 0 1-5.5-1.675 7.03 7.03 0 0 0 5.308-1.55c-1.533-.034-2.883-1.067-3.358-2.584a3.318 3.318 0 0 0 1.616-.066C3.142 11.15 1.933 9.625 1.933 7.85v-.042c.5.284 1.059.45 1.625.467C1.983 7.183 1.5 5.008 2.45 3.308 4.275 5.633 6.967 7.042 9.85 7.2a3.817 3.817 0 0 1 1.042-3.558c1.441-1.409 3.716-1.334 5.083.158a7.009 7.009 0 0 0 2.283-.908 3.755 3.755 0 0 1-1.575 2.058 7.093 7.093 0 0 0 2.059-.583 7.504 7.504 0 0 1-1.8 1.933h.008Z",
    fill: "#1D9BF0"
  })));
};
export default SvgTwitter;